// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"706bfc40","89":"d4936444","421":"6f6fc614"}[chunkId] + ".chunk.js";
};